export default "__VITE_PUBLIC_ASSET__1412fdcf__"